export const isRedirectTo = function() {
    return typeof ajax_var.redirect_to !== 'undefined' && ajax_var.redirect_to.length;
}

export const getRedirectTo = function() {
    return ajax_var.redirect_to;
}
